import { render, staticRenderFns } from "./tbxbbj.vue?vue&type=template&id=533428e0&scoped=true&"
import script from "./tbxbbj.vue?vue&type=script&lang=js&"
export * from "./tbxbbj.vue?vue&type=script&lang=js&"
import style0 from "./tbxbbj.vue?vue&type=style&index=0&id=533428e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533428e0",
  null
  
)

export default component.exports